import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { ServiceAssertionPerformance } from "@idw-types/data/reports/service-assertion-performance";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type GetServiceAssertionPerformanceRequestResponse = {
    serviceAssertionPerformances: Array<ServiceAssertionPerformance>;
};

export const getServiceAssertionPerformanceRequest = async (
    rpServiceId: string,
    version: string,
    policyDecisions: Array<string>,
    serviceOfferingIds: Array<string>,
    startDate: string,
    endDate: string,
    timeZone: string
): Promise<GenericNetworkResponse<GetServiceAssertionPerformanceRequestResponse>> => {
    const route = apiRoutes.reports.serviceAssertionPerformance.results;
    const queryParameters: Array<QueryParameter> = [];

    if (rpServiceId) {
        queryParameters.push({ parameter: "rpServiceID", value: rpServiceId });
    }
    if (version) {
        queryParameters.push({ parameter: "version", value: version });
    }
    if (policyDecisions?.length > 0) {
        queryParameters.push({ parameter: "policyDecisions", value: policyDecisions.join(",") });
    }
    if (serviceOfferingIds?.length > 0) {
        queryParameters.push({ parameter: "serviceOfferingIDs", value: serviceOfferingIds.join(",") });
    }
    if (startDate) {
        queryParameters.push({ parameter: "startDate", value: startDate });
    }
    if (endDate) {
        queryParameters.push({ parameter: "endDate", value: endDate });
    }
    if (timeZone) {
        queryParameters.push({ parameter: "timeZone", value: timeZone });
    }

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};
